import React from 'react'

import { Stack, Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

// import collabHorizontal from '../../assets/images/collab_horizontal.svg'
// import collabHorizontalWhite from '../../assets/images/collab_horizontal_white.svg'
import gift100 from '../../assets/images/gift100.png'
import { openExclusiveBonusModal } from '../../components/ExclusiveBonusModal'
import { Notification } from '../../components/Notification'
import { NotificationColorTypeEnum } from '../../components/Notification/types'
import { useThemeMode } from '../../theme/ThemeModeContext'

export const ExclusiveBonusBanner = () => {
  const { t } = useTranslation()
  const { resolvedMode } = useThemeMode()
  const { palette, spacing } = useTheme()

  // const collabImage = resolvedMode === 'dark' ? collabHorizontalWhite : collabHorizontal

  const colors = {
    light: {
      border: palette.primary.main,
      bgColor: '#eefaff',
    },
    dark: {
      border: '#1D3660',
      bgColor: '#153357',
    },
  }

  return (
    <Notification
      open
      colorType={NotificationColorTypeEnum.info}
      icon={false}
      onClick={openExclusiveBonusModal}
      styles={{
        display: 'block',
        border: `1px solid ${colors[resolvedMode].border}`,
        backgroundColor: colors[resolvedMode].bgColor,
        cursor: 'pointer',
        transition: 'background-color 180ms ease, border-color 180ms ease, box-shadow 180ms ease',
        boxShadow:
          resolvedMode === 'dark'
            ? '0 10px 24px rgba(0, 0, 0, 0.14)'
            : '0 10px 24px rgba(0, 128, 255, 0.06)',
        '&:hover': {
          backgroundColor: resolvedMode === 'dark' ? '#1B426F' : '#E3F4FF',
        },
      }}
    >
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        width="100%"
        gap={spacing(1)}
      >
        <Stack spacing={0.75} flex={1} minWidth={0}>
          <Box display="flex" alignItems="center" gap={spacing(1)} minWidth={0}>
            <Box
              component="img"
              src={gift100}
              alt="100% bonus"
              sx={{
                width: 'auto',
                height: 40,
                objectFit: 'contain',
                flexShrink: 0,
              }}
            />
            <Stack spacing={0.25} minWidth={0}>
              <Typography variant="body1" fontWeight={700} color="text.primary">
                {t(
                  'dashboard.reviewBanner.title',
                  'Tradelytic x Nuvesto: 100% bonus on your first deposit',
                )}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                {t(
                  'dashboard.reviewBanner.description',
                  'Fund today and trade with double capital from day one.',
                )}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Notification>
  )
}

export default ExclusiveBonusBanner
